/* eslint-disable no-undef */
import React, { Component, PureComponent } from 'react';
import { withGoogleMap, GoogleMap, Marker } from 'react-google-maps';
import { compose, withProps, lifecycle } from 'recompose';

let geocode;

export default class MapRow extends PureComponent {

    state = {
        latLng: this.props.latLng
    };

    componentDidUpdate() {
        this.setState({ latLng: this.props.latLng })
    }

    // shouldComponentUpdate(nextProps, nextState) {
    //     console.log('shouldComponentUpdate');
    //     return true;
        // if (nextState.position.lat !== this.state.position.lat || nextState.position.lng !== this.state.position.lng) {
        //     return true;
        // }
        //
        // if (nextProps.latLng.lat !== this.state.position.lat || nextProps.latLng.lng !== this.state.position.lng) {
        //     this.setState({position: nextProps.latLng, lat: nextProps.latLng.lat, lng: nextProps.latLng.lng});
        //     return true
        // }
        // return false;
    // }

    dragEndHandler = (e) => {
        if(!this.props.fixed && this.props.handleChange){
            const lat = e.latLng.lat();
            const lng = e.latLng.lng();
            const latLng = { lat, lng };
            geocode.geocode({ latLng }, responses => {
                if (responses && responses.length > 0) {
                    this.props.handleChange(responses[0].formatted_address, latLng);
                } else {
                    alert('Cannot determine address at this location.');
                }
            });
        }
    };

    mapClickedHandler = e => {
        if(!this.props.fixed && this.props.handleChange){
            const lat = e.latLng.lat();
            const lng = e.latLng.lng();
            const latLng = { lat, lng };
            geocode.geocode({ latLng }, responses => {
                if (responses && responses.length > 0) {
                    this.props.handleChange(responses[0].formatted_address, latLng);
                } else {
                    alert('Cannot determine address at this location.');
                }
            });
        }

    };

    onCenterChangedHandler = () => {

    };

    render() {
        const MyMapComponent = compose(
            withProps({
                loadingElement: (<div style={{ height: '100%' }} />),
                containerElement: (<div style={{ height: '230px' }} />),
                mapElement: (<div style={{ height: '100%' }} />)
            }),
            withGoogleMap,
            lifecycle({
                componentDidMount() {
                    let geocoder = new window.google.maps.Geocoder();
                    geocode = geocoder;
                }
            })
        )(props =>
        <div>
            <GoogleMap onClick={ this.mapClickedHandler }
                       defaultZoom={ 7 }
                       onCenterChanged={ this.onCenterChangedHandler }
                       defaultCenter={new window.google.maps.LatLng(this.state.latLng.lat, this.state.latLng.lng)}>

                <Marker defaultDraggable={!this.props.fixed}
                        onDragEnd={ this.dragEndHandler }
                        position={ this.state.latLng }/>

            </GoogleMap>

        </div>

        );

        return(
            <MyMapComponent/>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/GeoMap/GeoMap.js